import { AdminEditorService } from '../../admin.service';
import { SectionHandler } from '../entity.handler';
import { ZoneUpdateRequest } from '@key-telematics/fleet-api-client';

interface MapSectionValues {
    name?: string;
}

export class ZoneMapSectionHandler implements SectionHandler<any, MapSectionValues> {

    type = 'zone';
    icon = '';
    bulk: false;

    title = this.translate('TITLE');
    description = this.translate(`DESC`);

    constructor(
        public admin: AdminEditorService,
        public ownerId: string
    ) {
    }

    translate(key: string, values?: Object): string {
        return this.admin.translate(`EDITORS.ZONE.MAP.${key}`, values);
    }

    applyUpdate(_entity: any, _payload: any): Promise<any> {
        return Promise.reject(new Error('applyUpdate not supported'));
    }

    mapEntityToEditor(_entity: any): Promise<MapSectionValues> {
        return Promise.reject(new Error('mapEntityToEditor not supported'));
    }

    mapEditorToEntity(_entity: ZoneUpdateRequest, _values: MapSectionValues): Promise<ZoneUpdateRequest> {
        return Promise.reject(new Error('mapEditorToEntity not supported'));
    }

}
